<!-- Need more Fun? -->
<div
  id="group-outing"
  class="flex flex-col justify-start w-full h-full max-h-fit">
  <!-- `h3`'s base rule is 20px/700; this heading is 24px/800. -->
  <h3 class="mb-3 font-extrabold text-2xl">Need more Fun?</h3>
  <div class="gap-3 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 w-full">
    @for (upsell of transaction().transaction.event?.upsells; track upsell.id) {
      <app-upsell-toggle-card
        [upsell]="upsell"
        [checked]="
          upsellSelected !== null && upsell.id === upsellSelected()?.id
        "
        [disabled]="isUpsellDisabled(upsell)"
        [disabledTooltip]="'Not available while a discount code is active'"
        (toggle)="onChangeUpsell($event)" />
    }
  </div>
  @if (upsellSelected()) {
    <div
      class="flex justify-end items-center mt-4 pt-4 border-gray-200 border-t">
      <h5 class="font-bold text-main">
        Extra Cost (${{ upsellSelected()?.price | number: '1.2-2' }} x
        {{ totalTransactionSeats() }} Seats): ${{
          (upsellSelected()?.price || 0) * totalTransactionSeats()
            | number: '1.2-2'
        }}
      </h5>
    </div>
  }
</div>
